import { CAROUSEL_DATA_ITEMS } from './../../carousel.const';

import { Component, OnInit } from '@angular/core';
import { ICarouselItem } from '../carousel/Icarousel-item.metadata';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public carouselData: ICarouselItem[] = CAROUSEL_DATA_ITEMS;

  constructor() { }

  ngOnInit(): void {
  }

}
